/* globals urls, themeObj, Grid */


window.initCourseEventHandlers = (function($) {
	window.initCourseEventHandlers = function(container){
		if( container instanceof jQuery === false ){
			container = $(document);
		}
		else{
			// Trigger init events if this is targeting a particular container
			$('body').trigger('initPopups', [container.selector]);
			$('body').trigger('initSeatingPopups', [container.selector]);
			$('body').trigger('initTooltips', [container.selector]);
		}
		initCalendarPopups(container);
		initWaitlistButtons(container);
		initLoadingState(container);
		// TODO: test this all works as expected, make sure there aren't others.
	};
	
	window.initCalendarPopups = function(container){
		//ADD EVENT TO CALENDAR POPUP
		container.find( '.add-to-schedule' ).magnificPopup({
			mainClass: 'mfp-with-zoom',
			type: 'ajax',
			showCloseBtn: false,
			ajax: {
				settings: {
					type: 'POST',
					url: urls.ajax,
					data: {
						action:'addEventsToCalendar',
						day:$(this).data('day'),
						methodid:$(this).data('methodid')
					}
				}
			},
			callbacks: {
				ajaxContentAdded: function () {
					$('.popup-cancel-btn').on('click', function () {
						$.magnificPopup.close();
					});
					$('#iCal').on('click', function(e){
						e.preventDefault();
						$('#ics').submit();
					});
					$('#outlook').on('click', function(e){
						e.preventDefault();
						$('#ics').submit();
					});
				},
				elementParse: function () {
					this.st.ajax.settings.data = {
						action:'addEventsToCalendar',
						day:this.st.el.data('day'),
						methodid:this.st.el.data('methodid')

					};
				}
			}
		});
	};
	
	window.initWaitlistButtons = function(container){
		// unbind the current click events
		container.find('.join-waitlist').off("click");
		// Add a user to a course waitlist
		container.find('.join-waitlist').click(function(e){
			e.preventDefault();

			// Disable click listener, remove href, and grey out button
			$('.join-waitlist').off("click");
			$('.join-waitlist').removeAttr( 'href' );
			$('.join-waitlist').addClass('c-btn--disabled');

			// Get data needed to add this user to the waitlist
			var intCustomerId = $(this).data('customerid');
			var intCourseId = $(this).data('courseid');
			var intCategoryId = $(this).data('categoryid');

			// AJAX request to add the user to the waitlist
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: {
					action: 'add_user_to_waitlist',
					courseId: intCourseId,
					customerId: intCustomerId,
					enrollmentCategoryInstanceRecordID: intCategoryId
				}
			}).done(function( strResponseJson ){
				var objResponse = $.parseJSON( strResponseJson );

				// Reload + success message
				if( objResponse.success === true ){
					window.location = window.location.pathname + '?wlAdd=1';
				}
				// Reload + error message
				else{
					window.location = window.location.pathname + '?wlAdd=0';
				}
			});
		});
	};
	
	window.initLoadingState = function(container){
		container.find('.course--link, .join-waitlist').each(function(){
			$(this).on('click', function(){
				$(this).addClass('loading');
			});
		});
	};


	return initCourseEventHandlers;
})( jQuery );

initCourseEventHandlers();
